// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 9fbef606107a605d69c0edbcd8029e5d */ 
/**
 * Do not edit directly
 * Generated on Wed, 12 Mar 2025 15:28:06 GMT
 */



:root {
  --dui-font-weight-normal: 400;
  --dui-font-weight-medium: 500;
  --dui-font-weight-light: 300;
  --dui-font-weight-bold: 700;
  --dui-font-weight-black: 900;
}`, "",{"version":3,"sources":["webpack://./node_modules/@dhl-official/tokens/dist/css/semantics/font-weight.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;;;EAGE;;;;AAIF;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;AAC9B","sourcesContent":["/* 9fbef606107a605d69c0edbcd8029e5d */ \n/**\n * Do not edit directly\n * Generated on Wed, 12 Mar 2025 15:28:06 GMT\n */\n\n\n\n:root {\n  --dui-font-weight-normal: 400;\n  --dui-font-weight-medium: 500;\n  --dui-font-weight-light: 300;\n  --dui-font-weight-bold: 700;\n  --dui-font-weight-black: 900;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
